import React, { FC } from 'react'
import { Periods } from 'types'
import Price from 'Components/Shared/Price/Price'
import Title from 'Components/Shared/Title/Title'
import { useEFSData } from '@dectech/react-library'
import Features from '../Features/Features'
import CallToAction from '../CallToAction/CallToAction'
import { CardContentsStyle, CardStyle } from './CardStyle'
import CardHighlight from '../CardHighlight/CardHighlight'

/**
 * CardProps contains all appropriate props we should pass to nested components.
 */
export interface CardProps {
  title: string
  subtitle: string
  price?: number
  currency?: string
  priceString?: string
  hidePrice?: boolean
  features: string[]
  onSelect: () => void
  cardImage?: string
  purchaseButtonText?: string
  pricePeriod?: Periods
  highlightedText?: string
}

/**
 * Card is used to wrap all components we render in order to create each cart.
 * ThemeProvider component is used. By using the theme object we provide same styling options to all components.
 */
const Card: FC<CardProps> = ({
  title,
  subtitle,
  price,
  currency,
  priceString,
  hidePrice,
  features,
  onSelect,
  cardImage,
  purchaseButtonText,
  pricePeriod,
  highlightedText,
}) => {
  // TODO: This should be replaced to something using the props, as the card probably shouldn't rely on useEFSData hook
  const { showProductRangeOnly } = useEFSData()
  return (
    <CardStyle role="article">
      {highlightedText && <CardHighlight>{highlightedText}</CardHighlight>}
      <CardContentsStyle>
        {cardImage && <img src={cardImage} height="64" alt="cardHeader" />}
        <Title>
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </Title>
        <Title subtitle>
          <div dangerouslySetInnerHTML={{ __html: subtitle }} />
        </Title>
        <Features features={features} />
        {!hidePrice && (
          <Price
            price={price}
            currency={currency}
            priceString={priceString}
            pricePeriod={pricePeriod}
          />
        )}
        {!showProductRangeOnly && (
          <CallToAction
            buttonText={purchaseButtonText || 'Buy'}
            onClick={onSelect}
          />
        )}
      </CardContentsStyle>
    </CardStyle>
  )
}

export default Card
